import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-desktop-home-page',
  templateUrl: './desktop-home-page.component.html',
  styleUrls: ['./desktop-home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DesktopHomePageComponent {
}
